module.exports = __webpack_public_path__ + "static/media/progress-icon-white.d5fb17bd.svg";